import axios from '|/helpers/axios';
import { REVIEW_ORDER_ENDPOINTS } from './endpoints';
import { ReviewSummaryResponse, PlaceOrderResponse } from './types';

export const getReviewSummary = async (abortSignal: AbortSignal): Promise<ReviewSummaryResponse> =>
  axios
    .get<ReviewSummaryResponse>(REVIEW_ORDER_ENDPOINTS.GET_REVIEW_SUMMARY, {
      signal: abortSignal
    })
    .then(res => res.data);

export const placeOrder = async (abortSignal: AbortSignal): Promise<PlaceOrderResponse> =>
  axios
    .post<PlaceOrderResponse>(REVIEW_ORDER_ENDPOINTS.PLACE_ORDER, undefined, {
      signal: abortSignal
    })
    .then(res => res.data);

export const completeReviewOrder = async (abortSignal: AbortSignal): Promise<void> =>
  axios
    .post<never>(REVIEW_ORDER_ENDPOINTS.COMPLETE_REVIEW_ORDER, undefined, {
      signal: abortSignal
    })
    .then(() => undefined);

export const resetReviewOrder = async (abortSignal: AbortSignal): Promise<void> =>
  axios
    .delete<never>(REVIEW_ORDER_ENDPOINTS.COMPLETE_REVIEW_ORDER, { signal: abortSignal })
    .then(() => undefined);

export const selectVinEtching = async (abortSignal: AbortSignal): Promise<void> => {
  return axios
    .post<never>(REVIEW_ORDER_ENDPOINTS.SELECT_VIN_ETCHING, undefined, {
      signal: abortSignal
    })
    .then(() => undefined);
};

export const declineVinEtching = async (abortSignal: AbortSignal): Promise<void> => {
  return axios
    .post<never>(REVIEW_ORDER_ENDPOINTS.DECLINE_VIN_ETCHING, undefined, {
      signal: abortSignal
    })
    .then(() => undefined);
};
